module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "aboutus-mainpage"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "col-md-12 title-container"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', {
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v(_vm._s(_vm.state.subTitle1))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6",
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('div', {
    staticClass: "text-main-container"
  }, [_c('div', {
    staticClass: "medium-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.state.subTitle2))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.paragraphText)
    }
  })])])])]), _vm._v(" "), _c('mision'), _vm._v(" "), _c('valores'), _vm._v(" "), _c('organizacion')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 footer-container",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contacto",
      "tag": "a"
    }
  }, [_c('h3', [_vm._v("CONTÁCTANOS")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "1px solid white"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Copy right @2017 - All Rights Reserved")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6 img-contnt",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/imgs/nosotros_foto1.png"),
      "width": "100%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7bdb888"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nosotros/AboutusPage.vue
// module id = 157
// module chunks = 0